<template>
  <div class="suggestion-chips">
    <button
      v-for="suggestion in suggestions"
      :key="suggestion.id"
      class="suggestion-chip"
      :aria-label="`Quick suggestion: ${suggestion.text}`"
      @click="handleSuggestionClick(suggestion)"
    >
      <Icon
        v-if="suggestion.icon"
        :name="suggestion.icon"
      />
      {{ suggestion.text }}
    </button>
  </div>
</template>

<script setup>
const emit = defineEmits(["suggestionClick", "openInbox"]);
const suggestions = [
  { id: "1", text: "School hours", icon: "lucide:clock" },
  { id: "2", text: "Bus routes", icon: "lucide:bus" },
  { id: "3", text: "School calendars", icon: "lucide:calendar" },
  { id: "4", text: "Enrollment and registration", icon: "lucide:user-plus" },
  { id: "5", text: "Lunch menus", icon: "lucide:utensils" },
  { id: "6", text: "Contact Us", icon: "" }
];
function handleSuggestionClick(suggestion) {
  if (suggestion.text === "Contact Us") {
    emit("openInbox");
    return;
  }
  emit("suggestionClick", suggestion);
}
</script>

<style scoped>
.suggestion-chips{display:flex;flex-shrink:0;flex-wrap:wrap;gap:8px;justify-content:flex-end;padding:4px}.suggestion-chip{align-items:center;background:#fff;border:1px solid #e5e7eb;border-radius:20px;color:#374151;cursor:pointer;display:flex;font-size:13px;gap:6px;padding:8px 12px;transition:all .2s;white-space:nowrap}.suggestion-chip:hover{box-shadow:0 2px 4px rgba(0,0,0,.05);transform:translateY(-1px)}.suggestion-chip:active{box-shadow:none;transform:translateY(0)}.suggestion-chip:focus{outline:2px solid #6366f1;outline-offset:2px}
</style>
